import api from '../api';

export const getAreas = async (projectId, regionId) => {
  const res = await api.get(`/projects/${projectId}/regions/${regionId}/areas`);
  return res.data;
};

export const createArea = async (projectId, regionId, areaName, headcount = 0, dailyQuota = 0) => {
  const res = await api.post(`/projects/${projectId}/regions/${regionId}/areas`, { name: areaName, headcount, dailyQuota, provinceIds: [] });
  return res.data;
};

export const updateArea = async (projectId, regionId, areaId, updateData) => {
  const res = await api.put(`/projects/${projectId}/regions/${regionId}/areas/${areaId}`, updateData);
  return res.data;
};

export const deleteArea = async (projectId, regionId, areaId) => {
  const res = await api.delete(`/projects/${projectId}/regions/${regionId}/areas/${areaId}`);
  return res.data;
};

export const addProvinceToArea = async (projectId, regionId, areaId, provinceId) => {
  const res = await api.patch(`/projects/${projectId}/regions/${regionId}/areas/${areaId}`, { provinceId });
  return res.data;
};

export const removeProvinceFromArea = async (projectId, areaId, provinceId) => {
  const res = await api.delete(`/projects/${projectId}/areas/${areaId}/provinces/${provinceId}`);
  return res.data;
};